// Copyright (c) StrangeBee 2024

import { ICONS } from '@Constants/iconsApp';
import { THButton } from '@Molecules/Inputs/THButton/THButton';
import { THPopConfirm } from '@Molecules/Inputs/THPopConfirm/THPopConfirm';
import React, { ReactElement } from 'react';

interface DeleteButtonProps {
    label?: string;
    onConfirm?: (e?: React.MouseEvent<HTMLElement, MouseEvent>) => void;
    onClick?: React.MouseEventHandler<HTMLSpanElement>;
    className?: string;
    disabled?: boolean;
}

const DeleteButton = ({ onConfirm, label, className, onClick, disabled = false }: DeleteButtonProps): ReactElement => {
    const ButtonDelete = (
        <THButton
            className={className}
            type="link"
            danger
            icon={<ICONS.DeleteIcon />}
            onClick={onClick}
            disabled={disabled}
            size="small"
        />
    );

    return label ? (
        <THPopConfirm title={label} onConfirm={onConfirm} placement="bottomLeft" disabled={disabled}>
            {ButtonDelete}
        </THPopConfirm>
    ) : (
        ButtonDelete
    );
};

export default DeleteButton;
